import {dateDiffInSeconds} from '@gongxigames/framework/slot';
import {HandleFreeRoundsUpdateResponse} from './LightAndWonderType';
import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {PromotionTypes, IPromotionLogicInterface, PromotionBalanceEntryQualifier} from '@gongxigames/framework/promotions';

type FreeRoundsPropertyName =
    'ACTIVATIONID' |
    'CAMPAIGNID' |
    'CAMPAIGNVALUE' |
    'ENDDATE' |
    'MESSAGES' |
    'OPTIONS' |
    'REJECTABLE' |
    'STATUS' |
    'TOTALWIN' |
    'responseCallback';

type FreeRoundOptionPropertyName =
    'BETLEVEL' |
    'REMAININGROUNDS' |
    'TOTALROUNDS';

type FreeRoundsData = {
    bets: number[];
    wager: number;
    fractionSize: number;
    data: HandleFreeRoundsUpdateResponse;
};
export class LightAndWonderFreeRounds implements IPromotionLogicInterface {

    public static PING_BALANCE_DELAY = 3000;
    protected gmcFreeRoundsData?: HandleFreeRoundsUpdateResponse;
    protected wager = 0;
    protected fractionSize = 100;
    protected bets: number[] = [];

    public init(freeRoundsData: FreeRoundsData): void {
        this.update(freeRoundsData);
    }

    public update(freeRoundsData: FreeRoundsData): void {
        this.bets = freeRoundsData.bets;
        this.wager = freeRoundsData.wager;
        this.fractionSize = freeRoundsData.fractionSize;
        this.gmcFreeRoundsData = freeRoundsData.data;
    }

    public getID(): string {
        return this.getFreeRoundsProperty('CAMPAIGNID');
    }

    public getBet(): number {
        return this.getFreeRoundsOption('BETLEVEL') * this.fractionSize / this.wager;
    }

    public hasPromotion(): boolean {
        return this.isActive();
    }

    public getType(): PromotionTypes {
        return PromotionTypes.NULL;
    }

    public getWin(): number {
        return this.getFreeRoundsProperty('TOTALWIN');
    }

    public isActive(): boolean {
        return this.getRemainedRounds() > 0;
    }

    public subtractPromotion(): void {
        // NO-OP
    }

    public getRemainedRounds(): number {
        return this.getFreeRoundsOption('REMAININGROUNDS');
    }

    public getPlayedRounds(): number {
        return this.getTotalRounds() - this.getPlayedRounds();
    }

    public getTotalRounds(): number {
        return this.getFreeRoundsOption('TOTALROUNDS');
    }

    public getAdditionalFieldsForServerRequest(action: Action): Record<string, any> | undefined {
        return undefined;
    }

    public getPingBalanceDelay?(): number {
        return LightAndWonderFreeRounds.PING_BALANCE_DELAY;
    }

    protected getFreeRoundsProperty(fieldName: FreeRoundsPropertyName): any {
        return this.gmcFreeRoundsData?.freeRoundsInfo[fieldName];
    }

    protected getFreeRoundsOption(fieldName: FreeRoundOptionPropertyName): number {
        const options = this.gmcFreeRoundsData?.freeRoundsInfo['OPTIONS'];

        if (!options || options.length <= 0) {
            return 0;
        }

        return options[0][fieldName];
    }

    isCurrentInUse(): boolean {
        return this.isActive() && this.getRemainedRounds() < this.getTotalRounds();
    }

    isCurrentExpired(): boolean {
        const endDate = this.getFreeRoundsProperty('ENDDATE');
        const isExpired = dateDiffInSeconds(Date.now(), new Date(`${endDate}`).getTime()) < 0;

        return isExpired;
    }

    getQualifier(): PromotionBalanceEntryQualifier {
        return 'free-round';
    }
}
